import { useMemo } from 'react';

interface StateBasedProps<T> {
  default: T;
  hover?: T;
}

export const useStateBasedProps = <T>(
  prop: T | StateBasedProps<T> | undefined,
  isHovered: boolean,
  hoverEnabled: boolean = true,
): T | undefined => {
  return useMemo(() => {
    if (prop === undefined || prop === null) return undefined;
    if (typeof prop === 'object' && prop !== null && 'default' in prop) {
      return hoverEnabled && isHovered && prop.hover ? prop.hover : prop.default;
    }
    return prop as T;
  }, [prop, isHovered, hoverEnabled]);
};
